import React, { useState, useEffect } from "react";
import "./CookieBanner.css";

const CookieBanner = () => {
  // Banner'ı başlangıçta görünür yapıyoruz
  const [visible, setVisible] = useState(true);
  const [showOptions, setShowOptions] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Her zaman gerekli
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    // Debug için log ekliyorum
    console.log("Cookie consent check:", localStorage.getItem("cookieConsented"));
    
    // Daha önce onay verilmediyse banner'ı göster
    const consent = localStorage.getItem("cookieConsented");
    if (!consent) {
      console.log("No consent found, showing banner");
      // Banner zaten görünür olduğu için burada bir şey yapmaya gerek yok
    } else {
      console.log("Consent found:", consent);
      try {
        setPreferences(JSON.parse(consent));
        // Kayıtlı bir tercih varsa banner'ı gizle
        setVisible(false);
      } catch (e) {
        // Geçersiz JSON durumunda varsayılan değerleri kullan
        console.error("Error parsing consent:", e);
      }
    }

    // Geliştirme ortamında banner'ı sıfırlamak için global fonksiyon
    if (process.env.NODE_ENV === 'development') {
      window.resetCookieBanner = () => {
        localStorage.removeItem("cookieConsented");
        setVisible(true);
        console.log("Cookie banner reset");
      };
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem("cookieConsented", JSON.stringify(allAccepted));
    setPreferences(allAccepted);
    setVisible(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem("cookieConsented", JSON.stringify(preferences));
    setVisible(false);
  };

  const handleToggleOption = (option) => {
    setPreferences({
      ...preferences,
      [option]: !preferences[option]
    });
  };

  const togglePrivacyPolicy = (e) => {
    e.preventDefault();
    setShowPrivacyPolicy(!showPrivacyPolicy);
  };

  if (!visible) return null;

  return (
    <>
      <div className="cookie-banner">
        <div className="cookie-content">
          <div className="cookie-header">
            <h3>Cookie Settings</h3>
            {showOptions && (
              <button className="cookie-close-btn" onClick={() => setShowOptions(false)}>
                &times;
              </button>
            )}
          </div>
          
          <p className="cookie-message">
            This site uses cookies to improve your experience. See our <button onClick={togglePrivacyPolicy} className="privacy-link" style={{background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', font: 'inherit'}}>Privacy Policy</button> for more information.
          </p>

          {showOptions && (
            <div className="cookie-options">
              <div className="cookie-option">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.necessary} 
                    disabled={true} 
                  />
                  <span>Necessary (Required)</span>
                </label>
                <p>Essential cookies for the website to function properly.</p>
              </div>
              
              <div className="cookie-option">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.analytics} 
                    onChange={() => handleToggleOption('analytics')} 
                  />
                  <span>Analytics</span>
                </label>
                <p>Cookies that help us understand how you use our website.</p>
              </div>
              
              <div className="cookie-option">
                <label>
                  <input 
                    type="checkbox" 
                    checked={preferences.marketing} 
                    onChange={() => handleToggleOption('marketing')} 
                  />
                  <span>Marketing</span>
                </label>
                <p>Cookies used to deliver relevant ads and marketing campaigns.</p>
              </div>
            </div>
          )}

          <div className="cookie-actions">
            {!showOptions && (
              <button className="cookie-settings-btn" onClick={() => setShowOptions(true)}>
                Customize
              </button>
            )}
            
            {showOptions ? (
              <button className="cookie-save-btn" onClick={handleSavePreferences}>
                Save Preferences
              </button>
            ) : (
              <button className="cookie-accept-btn" onClick={handleAcceptAll}>
                Accept All
              </button>
            )}
          </div>
        </div>
      </div>

      {showPrivacyPolicy && (
        <div className="privacy-policy-modal">
          <div className="privacy-policy-content">
            <div className="privacy-policy-header">
              <h2>Privacy Policy</h2>
              <button className="privacy-close-btn" onClick={togglePrivacyPolicy}>&times;</button>
            </div>
            <div className="privacy-policy-body">
              <h3>Introduction</h3>
              <p>This Privacy Policy explains how we collect, use, and protect your personal information when you use our website.</p>
              
              <h3>Information We Collect</h3>
              <p>We may collect the following types of information:</p>
              <ul>
                <li>Personal identification information (Name, email address, etc.)</li>
                <li>Usage data and analytics</li>
                <li>Cookies and tracking information</li>
              </ul>
              
              <h3>How We Use Your Information</h3>
              <p>We use your information to:</p>
              <ul>
                <li>Improve our website and services</li>
                <li>Personalize your experience</li>
                <li>Process transactions</li>
                <li>Send periodic emails (if applicable)</li>
              </ul>
              
              <h3>Cookie Policy</h3>
              <p>Our website uses cookies to enhance your browsing experience. You can choose to disable cookies in your browser settings, but some parts of our website may not function properly.</p>
              
              <h3>Third-Party Disclosure</h3>
              <p>We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties.</p>
              
              <h3>Data Security</h3>
              <p>We implement a variety of security measures to maintain the safety of your personal information.</p>
              
              <h3>Your Rights</h3>
              <p>You have the right to access, correct, or delete your personal information. Please contact us if you wish to exercise these rights.</p>
              
              <h3>Changes to This Policy</h3>
              <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
              
              <h3>Contact Us</h3>
              <p>If you have any questions about this Privacy Policy, please contact us.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner; 